document.addEventListener('DOMContentLoaded', function () {
  if (typeof Swiper !== 'undefined' && document.querySelector('.typeSwiper')) {
    new Swiper('.typeSwiper', {
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    }
    });
  }

  if (typeof Swiper !== 'undefined' && document.querySelector('.reviews__list')) {
    new Swiper('.reviews__list', {
    spaceBetween: 20,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      1201: {
        slidesPerView: 4,
      },
      1000: {
        slidesPerView: 3,
      },
      741: {
        slidesPerView: 2,
      },
      740: {
        slidesPerView: 1,
      }
    }
    });
  }
});
